module.exports = __webpack_public_path__ + "img/panel8.4cd71815.jpg";